
/**
 * @fileoverview Cookie storage utility for Click&Pledge.
 * Provides methods for setting, getting, and removing cookies with proper encoding.
 */

/**
 * Cookie storage utility object that provides methods for cookie management.
 * Handles encoding/decoding and expiration dates automatically.
 */
const cookieStorage = {
    /**
   * Sets a cookie with the specified key, value, and expiration.
   *
   * @param {string} key - Cookie name
   * @param {string} value - Cookie value (will be URL encoded)
   * @param {number} days - Number of days until expiration (default: 7)
   */
    setItem: (key, value, days = 7) => {
        const expires = new Date();

        expires.setDate(expires.getDate() + days);
        document.cookie = `${key}=${encodeURIComponent(value)};expires=${expires.toUTCString()};path=/`;
    },

    /**
   * Gets a cookie value by key.
   *
   * @param {string} key - Cookie name to retrieve
   * @returns {string|null} Cookie value (URL decoded) or null if not found
   */
    getItem: key => {
        const name = `${key}=`;
        const decodedCookie = decodeURIComponent(document.cookie);
        const ca = decodedCookie.split(';');

        for (let c of ca) {
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }

        return null;
    },

    /**
   * Removes a cookie by setting its expiration to the past.
   *
   * @param {string} key - Cookie name to remove
   */
    removeItem: key => {
        document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    }
};

export default cookieStorage;
